/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { StyledMainPicturePage } from '../StyledMainPicturePage';
import { Media }                 from '../../../styles/utilities';
import { transparentize }        from "polished/lib/index";
import { Colours }               from "../../../styles/variables";

/*********************************************************************************
 2. Component
 *********************************************************************************/

export const  StyledMainPictureHybridPage = StyledMainPicturePage.extend`
  min-height: auto;
  ${Media.Tablet`
    height: 100vh;
    position: relative;
    box-shadow: 0 1px 1px 0 ${transparentize(0.7, Colours.Tundora)};
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledMainPictureHybridPage/index.js